import React from "react";

function Switch({ checked, onChange }) {
  return (
    <button
      type="button"
      onClick={onChange}
      className={`w-11 h-6 rounded-full transition-colors relative flex items-center flex-shrink-0 outline-none ${
        checked ? "bg-blue-600" : "bg-gray-200"
      }`}
    >
      <span
        className={`w-5 h-5 bg-white rounded-full absolute shadow-sm transition-transform duration-200 ease-out ${
          checked ? "translate-x-5" : "translate-x-0.5"
        }`}
      />
    </button>
  );
}

export default function ProfileSwitch({
  title,
  description,
  icon: Icon,
  checked,
  onChange,
}) {
  return (
    <div className="p-4 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3.5">
        <div className="w-10 h-10 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center text-tuncayBlue text-lg flex-shrink-0">
          {Icon && (typeof Icon === "function" ? <Icon /> : Icon)}
        </div>

        <div>
          <h4 className="font-semibold">{title}</h4>
          <p className="text-base text-gray-600 mt-0.5">{description}</p>
        </div>
      </div>

      <Switch checked={checked} onChange={onChange} />
    </div>
  );
}
